// extracted by mini-css-extract-plugin
export default {"center":"center___iRrDCz1"};